import { render, staticRenderFns } from "./CapacityForm.vue?vue&type=template&id=3c4806de"
import script from "./CapacityForm.vue?vue&type=script&lang=js"
export * from "./CapacityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports